import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'limitTo',
    standalone: false
})
export class LimitToPipe implements PipeTransform {
  /**
   * ex : <p>{{ myLongText | limitTo:50 }}</p>
   * @param value
   * @param limit
   * @param useEllipsis
   * @returns
   */
  transform(value: string, limit: number, useEllipsis: boolean = true): string {
    if (!value) return '';
    if (value.length <= limit) return value;
    const truncated = value.substring(0, limit);
    return useEllipsis ? `${truncated}...` : truncated;
  }
}
